import axios from "axios";

function traduzirMensagemErro(mensagem) {
  if (!mensagem) return "Ocorreu um erro ao processar a solicitacao.";

  const texto = String(mensagem);
  const traducoesExatas = {
    "Server Error": "Erro interno no servidor. Atualize a lista para conferir se a operacao foi concluida.",
    "Network Error": "Nao foi possivel conectar ao servidor. Verifique sua conexao e tente novamente.",
    "Request failed with status code 500": "Erro interno no servidor. Atualize a lista para conferir se a operacao foi concluida.",
    "Request failed with status code 404": "Registro nao encontrado.",
    "Request failed with status code 403": "Voce nao tem permissao para realizar esta acao.",
    "Request failed with status code 401": "Sua sessao expirou. Faca login novamente.",
    "The given data was invalid.": "Confira os campos informados e tente novamente.",
  };

  if (traducoesExatas[texto]) return traducoesExatas[texto];

  const traducoesParciais = [
    [/already been taken/i, "Este valor ja esta cadastrado."],
    [/field is required/i, "Preencha todos os campos obrigatorios."],
    [/must be a valid email/i, "Informe um email valido."],
    [/must be at least/i, "Informe um valor com o tamanho minimo exigido."],
    [/confirmation does not match/i, "A confirmacao da senha nao confere."],
  ];

  const traducao = traducoesParciais.find(([padrao]) => padrao.test(texto));
  return traducao ? traducao[1] : texto;
}

export const api = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;

    if (data?.errors) {
      Object.keys(data.errors).forEach((campo) => {
        data.errors[campo] = data.errors[campo].map(traduzirMensagemErro);
      });
    }

    if (data) {
      data.message = traduzirMensagemErro(data.message || error.message);
    } else {
      error.message = traduzirMensagemErro(error.message);
    }

    return Promise.reject(error);
  }
);
